import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { buildUrl } from 'utils';
import { Card } from 'components/UI';
import Loading from 'components/Loading';
import SubscriptionsList from './SubscriptionsList';
import { useStyles } from './Subscriptions.styled';
import { Box, Typography, Button } from '@material-ui/core';
import { SubscriptionsActions } from 'state/modules/subscriptions';

const SubscriptionsTableList = ({ history, type, customParams }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { loading, pagination, subscriptions } = useSelector((state) => state.subscriptions);

  const [params, setParams] = useState({
    page: 1,
    limit: 3,
    ...customParams,
  });

  const fetchSubscriptions = useCallback(
    (params = {}) => {
      dispatch(SubscriptionsActions.fetchSubscriptions(params));
    },
    [dispatch]
  );

  useEffect(() => {
    fetchSubscriptions(params);
  }, [fetchSubscriptions, params]);

  const handlePageChange = (e, page) => {
    const newParams = { page: page + 1, limit: params.limit };
    setParams({ ...params, ...newParams });
  };

  const viewAllSubscriptions = () => {
    let params = '';
    if (type === 'vehicle') {
      params = customParams?.vehicle_id ? `?vehicle_id=${customParams?.vehicle_id}` : '';
    } else if (type === 'user') {
      params = customParams?.user_id ? `?user_id=${customParams?.user_id}` : '';
    }
    history.push(buildUrl(`/subscriptions${params}`));
  };

  const title = (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography color="textPrimary" component="span">
        <Box fontSize={14} fontWeight="fontWeightMedium" data-cy="task-title">
          {i18n.t('subscriptions.title')}
        </Box>
      </Typography>
      <Button
        type="button"
        variant="text"
        color="primary"
        data-cy="view-all-subscriptions"
        disableFocusRipple={true}
        className={classes.button}
        onClick={viewAllSubscriptions}
      >
        {i18n.t('subscriptions.view_all')}
      </Button>
    </Box>
  );

  return (
    <Card title={title} headerActionType="vertical">
      {loading ? (
        <Box
          className={classes.loadingContainer}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Loading />
        </Box>
      ) : (
        <>
          <SubscriptionsList
            params={params}
            pagination={pagination}
            subscriptions={subscriptions}
            handleChangePage={handlePageChange}
          />
        </>
      )}
    </Card>
  );
};

SubscriptionsTableList.propTypes = {
  history: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(['vehicle', 'user']).isRequired,
};

SubscriptionsTableList.defaultProps = {
  title: '',
  type: 'user',
  isCustomer: false,
};

export default SubscriptionsTableList;
